import { onUnmounted, ref } from 'vue';
import { DeviceTypeHelper, DeviceFamily } from '@ncss/models/dist/v3';
import { useLiveDevices } from '@/http-services/live-device.service';
import {
  GatewayCommandMessage,
  GatewayCommandMessageType,
  GatewaySyncMessage,
  GatewaySyncMessageType,
} from '@ncss/models';

export type DeviceSyncStatus = 'IDLE' | 'SYNCING' | 'COMPLETE' | 'FAILED';

export function useGatewaySync() {
  const { start, stop, sendMessage, onMessage } = useLiveDevices();
  const syncStatus = ref<DeviceSyncStatus>('IDLE');

  async function sync(deviceId?: number | null): Promise<boolean> {
    if (!deviceId || DeviceTypeHelper.GetFamilyBySerialNumber(deviceId) !== DeviceFamily.GATEWAY) {
      return false;
    }
    syncStatus.value = 'SYNCING';
    const success = await new Promise<boolean>((resolve, reject) => {
      start(deviceId);
      onMessage((msg) => {
        if (msg instanceof GatewaySyncMessage && msg.type === GatewaySyncMessageType.SYNC_FINISHED) {
          clearTimeout(t);
          stop();
          resolve(true);
        }
      });
      sendMessage(new GatewayCommandMessage({ type: GatewayCommandMessageType.FORCE_SYNC, gatewayId: deviceId }));
      const t = setTimeout(() => {
        stop();
        resolve(false);
      }, 30000);
    });
    syncStatus.value = success ? 'COMPLETE' : 'FAILED';
    await new Promise((resolve) => setTimeout(resolve, 2000));
    syncStatus.value = 'IDLE';
    return success;
  }

  onUnmounted(() => stop());

  return {
    syncStatus,
    sync,
  };
}
